<template>
    <teleport to="body">
        <div v-show="show" :class="['modal', className]" tabindex="-1" @keyup.esc="onEsc">
            <div v-if="mask" :style="customMaskStyles" class="modal__mask" @click="onClickMask" />
            <div
                ref="modalDialog"
                :class="
                    ({
                        'modal__dialog--default': layout === 'default',
                        'modal__dialog--delete': layout === 'delete',
                    },
                    dialogClasses)
                "
                :style="{ ...dialogStyle, ...customStyles }"
                class="modal__dialog"
            >
                <VueFeather v-if="closeButton" class="modal__close" type="x-circle" @click="$emit('hide')" />
                <slot></slot>
            </div>
        </div>
    </teleport>
</template>

<script>
    import { onMounted, ref, watchEffect } from 'vue';
    import VueFeather from 'vue-feather';

    export default {
        name: 'Modal',
        components: {
            VueFeather,
        },
        props: {
            show: {
                type: Boolean,
                default: true,
            },
            mask: {
                type: Boolean,
                default: true,
            },
            closeButton: {
                type: Boolean,
                default: true,
            },
            closeOnEsc: {
                type: Boolean,
                default: false,
            },
            closeOnClickMask: {
                type: Boolean,
                default: true,
            },
            className: {
                type: String,
                default: '',
            },
            size: {
                type: String,
                required: false,
                default: '',
            },
            customStyles: {
                type: Object,
                default: () => ({}),
            },
            customMaskStyles: {
                type: Object,
                default: () => ({}),
            },
            layout: {
                type: String,
                default: 'default',
                required: false,
            },
        },
        emits: ['hide', 'clickMask'],
        setup(props, { emit }) {
            const dialogClasses = ref([]);

            const onEsc = () => {
                if (props.show && props.closeOnEsc) {
                    emit('hide');
                }
            };

            const onClickMask = () => {
                emit('clickMask');

                if (props.closeOnClickMask) {
                    emit('hide');
                }
            };

            if (props.size) {
                dialogClasses.value.push(`modal__dialog--${props.size}`);
            }

            const modalDialog = ref(null);
            const dialogStyle = ref({});

            const centerDialog = () => {
                const dialog = modalDialog.value;
                if (!dialog) return;

                const windowHeight = window.innerHeight;
                const dialogHeight = dialog.offsetHeight;

                if (windowHeight < dialogHeight) {
                    dialogStyle.value = { top: `0`, opacity: 1 };
                } else {
                    dialogStyle.value = {
                        top: `${(windowHeight - dialogHeight) / 2}px`,
                        opacity: 1,
                    };
                }
            };

            onMounted(() => {
                centerDialog();
                // Fix some of the stragglers that doesn't want to be centered
                setTimeout(centerDialog, 250);
            });

            // watch for changes on prop show and if it changes, center the dialog
            watchEffect(() => {
                if (props.show) {
                    centerDialog();
                }
            });

            // onUpdated(centerDialog);

            // Add event listener for window resize
            window.addEventListener('resize', centerDialog);

            // Clean up event listener on unmount
            watchEffect((onInvalidate) => {
                onInvalidate(() => {
                    window.removeEventListener('resize', centerDialog);
                });
            });

            return {
                dialogStyle,
                dialogClasses,
                onEsc,
                onClickMask,
                modalDialog,
            };
        },
    };
</script>
